import { faPlus } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Box,
  Dropdown,
  Menu,
  MenuButton,
  MenuItem,
  Typography,
} from "@mui/joy";
import { memo } from "react";
import { type RuleBasedAudienceCombinatorOperator } from "features/mediaDataRoom/models";
import { mapCombinatorOperatorToOption } from "../../config";

interface AddAudienceButtonProps {
  combinatorOperators: RuleBasedAudienceCombinatorOperator[];
  handleAddAudience: (value: RuleBasedAudienceCombinatorOperator) => void;
  disabled?: boolean;
}

const AddAudienceButton = memo<AddAudienceButtonProps>(
  ({ combinatorOperators, handleAddAudience, disabled = false }) => {
    return (
      <Dropdown>
        <MenuButton
          color="primary"
          disabled={disabled}
          startDecorator={<FontAwesomeIcon fixedWidth={true} icon={faPlus} />}
          sx={{ mt: 1, width: "100%" }}
          variant="soft"
        >
          Combine with another audience
        </MenuButton>
        <Menu>
          {combinatorOperators.map((operator) => {
            const option = mapCombinatorOperatorToOption[operator];
            const Icon = option.icon;
            return (
              <MenuItem
                key={operator}
                onClick={() => handleAddAudience(operator)}
              >
                <Icon />
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Box>
                    <Typography>{option.label}</Typography>
                    <Typography level="body-sm">
                      {option.description}
                    </Typography>
                  </Box>
                </Box>
              </MenuItem>
            );
          })}
        </Menu>
      </Dropdown>
    );
  }
);

AddAudienceButton.displayName = "AddAudienceButton";

export default AddAudienceButton;
